/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { LoyaltyProgramSummaryV2Dto } from './loyaltyProgramSummaryV2Dto';
import { LocationInfoDto } from './locationInfoDto';


export interface ClientCouponV2Dto { 
    id?: number;
    uuid?: string;
    name?: string;
    description?: string;
    duration?: number;
    image?: string;
    price?: number;
    enabled?: boolean;
    available?: boolean;
    unlimitedDuration?: boolean;
    loyaltyProgram?: LoyaltyProgramSummaryV2Dto;
    boughtCoupons?: number;
    firstCouponExpiration?: string;
    firstCouponExpirationTime?: string;
    validAtAllLocations?: boolean;
    validLocations?: Array<LocationInfoDto>;
}

